import { useState } from "react";

export function useActionConfirmationDialog() {
    const [isActionConfirmationDialogOpen, setIsActionConfirmationDialogOpen] = useState<boolean>(false);
    const [confirmedAction, setConfirmedAction] = useState<() => void | Promise<void>>(() => { });
    const [confirmationMessage, setConfirmationMessage] = useState<string>('');
    const [submitButtonName, setSubmitButtonName] = useState<string | null>(null);
    
    return {
        isActionConfirmationDialogOpen,
        setIsActionConfirmationDialogOpen,
        confirmedAction,
        setConfirmedAction,
        confirmationMessage,
        setConfirmationMessage,
        submitButtonName,
        setSubmitButtonName,
    };
}
